<template>
  <div>
    <div>
      <ProductRadioButtons
        v-if="options.length >= 1"
        :default-val="
          activeProduct[optionKey] ? activeProduct[optionKey] : defaultOption
        "
        :options="options"
        :hide-border="true"
        @radio-value-changed="handleOptionChanged($event, optionKey)"
      />
    </div>
  </div>
</template>
<script>
// import ProductOptionButtons from "./ProductOptionButtons.vue";
import ProductRadioButtons from "./ProductRadioButtons.vue";
export default {
  name: "ProductOptionSelector",
  components: {
    // ProductOptionButtons,
    ProductRadioButtons
},
  props: {
    activeProduct: Object,
    products: Array,
    productType: String,
    optionKey: String,
    selectedProduct: Object,
    defaultOption: String,
    shipping: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      options: this.deriveOptions(this.optionKey),
      IGNORE_SHIPPING_FABRICS: ["Decide Later", "Customer Own Materials"],
    };
  },
  methods: {
    handleOptionChanged(value, option) {
      let options = [{ option, value }];
      this.$emit("option-changed", options);
    },
    deriveOptions(option) {
      let options = [];
      this.products.forEach((product) => {
        if (product[option] && !options.includes(product[option])) {
          options.push(product[option]);
        }
      });
      if (options.length <= 1) {
        options.push(this.defaultOption);
      }
      options = options.sort((firstOption, secondOption) =>
        firstOption < secondOption ? -1 : 1
      );
      return options;
    },
  },
};
</script>
<style scoped>
.shipping_length {
  font-weight: 600;
  font-size: 14px;
  padding: 10px 20px;
  border: 1px solid #cbc8c3;
  background-color: #f2f2f2;
  border-radius: 10px;
  display: inline-block;
}
</style>
